module.exports = __webpack_public_path__ + "images/category_lp/watch/omega/store_images/2@2x_d2a02c96e8754cae144caf332c357977.png";